export default "__VITE_ASSET__DPyRttDY__"